export default "<app-pending-batch-payments-list></app-pending-batch-payments-list>\r\n"